import { Container, Row, Col, Card } from "react-bootstrap";
import "./index.scss";
import img from "../../../assets/images/bg.png";
import tem from "../../../assets/images/tem.png";
import { StarIcon } from "../../../assets/icons/StarIcon";
import { FleshIcon } from "../../../assets/icons/FleshIcon";
import { useNavigate } from "react-router-dom";
import CategoryService from "../../../services/category";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { useEffect, useState } from "react";
export default function TestimonialsSection() {
  const [nosPacksCategory, setNosPacksCategory] = useState(null);
  const navigate = useNavigate();
  const categoryService = new CategoryService();

  const loadNosPacksCategory = async () => {
    try {
      const res = await categoryService.getAllCategories();
      const nosPacks = res?.data?.find(cat => 
        cat.title?.toLowerCase() === "nos packs"
      );
      setNosPacksCategory(nosPacks);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
  };

  useEffect(() => {
    loadNosPacksCategory();
  }, []);

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const getImageURL = (userId) => {
    return `${apiUrl}/categories/${userId}/image`;
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-bg">
        <Row className="align-items-center justify-content-end mx-0 ">
          {/* Colonne gauche : Avis clients */}
          <Col md={5} className="ps-5 pe-5 pe-md-5 ">
            <h2 className="title">
              Elles ont testé, <br /> elles adorent !
            </h2>

            <Card className="testimonial-card">
              <div className="d-flex  align-items-center justify-content-between mb-3 ">
                {" "}
                <h6 className="name">Syrine M.</h6>
                <StarIcon />
              </div>
              <p>
                J’ai enfin trouvé une marque naturelle qui respecte ma peau
                sensible. Les résultats sont visibles dès les premières
                utilisations.
              </p>
            </Card>

            <Card className="testimonial-card">
              <div className="d-flex  align-items-center justify-content-between mb-3 ">
                {" "}
                <h6 className="name">Nesrine B.</h6>
                <StarIcon />
              </div>
              <p>
                Les produits Alma Secret sont incroyables ! Mon shampoing laisse
                mes cheveux doux et brillants comme jamais.
              </p>
            </Card>

            <Card className="testimonial-card">
              <div className="d-flex  align-items-center justify-content-between mb-3 ">
                {" "}
                <h6 className="name">Amel K.</h6>
                <StarIcon />
              </div>
              <p>
                J’adore l’odeur et la texture des crèmes, on sent vraiment la
                qualité et la naturalité des ingrédients.
              </p>
            </Card>
          </Col>

          {/* Colonne droite : Image avec Nos Packs */}
          <Col md={6} className="image-col">
            <div className="image-wrapper1">
              <img
                src={img}
                alt="Femme tenant un produit"
                className="main-image"
              />
              {nosPacksCategory && (
                <div 
                  className="product-card nos-packs-card"
                  onClick={() => {
                    navigate(`/all-products?category=${nosPacksCategory._id}`);
                    window.scrollTo(0, 0);
                  }}
                >
                  <img 
                    src={getImageURL(nosPacksCategory._id)} 
                    alt={nosPacksCategory.title} 
                    className="product-img1" 
                  />
                  <div className="product-info">
                    <h6>{nosPacksCategory.title}</h6>
                    <p>
                    Des formules innovantes et inédites, enrichies en ingrédients biologiques, en eau thermale et en actifs validés 
                    </p>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
